import axios from "axios"
import { getBaseURL } from "../../../../../api/axios"

export default async function getVerifiedToken(token) {
	const baseUrl = getBaseURL();
	const url = `${baseUrl}user/verify`;
	const response = await axios.post(url, {token},{
		headers:{
			"Authorization":"Bearer "+token,
			"Accept":"application/json"
		}
	})

	return response ? response?.data?.token : response
	
}
